import {FULFILLED} from 'redux-promise-middleware';
import {SagaIterator} from 'redux-saga';
import {clearCartAdd} from 'actions/cart/cart';

import {QUOTE_ITEM} from 'constants/actions';

import {take, put} from 'redux-saga/effects';

/**
 * Send EEC impression analytics for the added product.
 */
export default function* EECCartImpressions(): SagaIterator {
    yield take(`${QUOTE_ITEM.GET_ITEMS}_${FULFILLED}`);
    yield put(clearCartAdd());
}
